import BasicSelect from "components/BasicInputs/BasicSelect";

export interface SelectProps {
  val: any;
  data: { options: any[] };
  options?: any;
  row: any;
  colKey: string;
  onChange: (item: any) => void;
  withBorder?: boolean;
  index?: number
}
export default function Select(props: SelectProps) {
  const { val, options, row, colKey, withBorder, index } = props;
  const placeholder = (options && options.placeholder) || "";
  const labelKey = (options && options.labelKey) || "label";
  const label = !val ? placeholder : typeof val === "string" ? val : val[labelKey] ? val[labelKey] : "";
  let data = props?.data?.options;
  let inputProps = props?.options?.inputProps;
  const isDep =
    options && options.dependentData && options.depKey && row[options.depKey] && options.normalizeFunction;
  if (isDep) data = options.normalizeFunction(row[options.depKey]);
  const isNested = data && options && options.nested;
  const noData = !data || (data && data.length === 0);
  const noDataPlaceholder = "گزینه ای وجود ندارد";
  const onClear = props?.options?.onClear;


  return (
    <BasicSelect
      options={data}
      isNested={isNested}
      disabled={inputProps?.disabled}
      btnStyle={{ ...(!withBorder && { border: 0 }) }}
      placeholder={label}
      withSearch
      defaultValue={val}
      onChange={(val, option) => {
        let onChange = option.onChange || options.onChange || props.onChange || undefined;
        if (isNested) onChange = options.onChange;
        const reRender = (options && options.reRender) || false;
        let res = option;
        if (option.item) res = option.item;
        onChange(res, { row, colKey, label, reRender, options, index });
      }}
      onClear={() => onClear && onClear(row)}
      {...inputProps}
    />
  );
}
